module.exports = __webpack_public_path__ + "static/img/scanpy.90e4d5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scanpy.png
// module id = CShv
// module chunks = 1